<template>
  <baidu-map class="map" :zoom="zoom" center="成都">
     <bm-control>
      <v-btn @click="addZoom(19)">Bigger</v-btn>
      <v-btn @click="addZoom(10)">reset</v-btn>
      <v-btn @click="addZoom(3)">Smaller</v-btn>
    </bm-control>
    <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
  </baidu-map>
</template>
<script>
export default {
  data () {
    return {
      zoom: 10
    }
  },
  methods: {
    addZoom (level) {
      this.zoom = level
    }
  }
}
</script>
<style scoped>
.map {
  width: 100%;
  height: 100%;
}
</style>